import styled from 'react-emotion';

import BaseButton from '@material-ui/core/Button';
import ArrowForward from '@material-ui/icons/ArrowForward';
import Add from '@material-ui/icons/Add';

import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';

const containerStyle = `
  font-size: 12px;
  color: ${colors.grey11};
  display: flex;
  align-items: center;
`;
export const ClickableLegendContainer = styled('div')`
  ${containerStyle}
  cursor: pointer;
`;

export const LegendContainer = styled('div')`
  ${containerStyle}
`;

export const Button = styled(BaseButton)`
  font-family: ${theme.font.family.workSans};
  text-transform: none;
  color: ${colors.designSystem.purple70};
  & > span > svg {
    margin-right: 8px;
  }
  flex: 1;
  justify-content: start;
`;

export const ParticipantsContainer = styled('div')`
  height: 190px;
  overflow-y: scroll;
`;

export const PurpleArrowForwardIcon = styled(ArrowForward)`
  color: ${colors.designSystem.purple70};
  margin-left: 6px;
`;

export const AddIcon = styled(Add)`
  font-size: ${theme.font.size.headline};
  color: ${colors.designSystem.purple70};
  font-weight: ${theme.font.weight.semiBold};
`;
